export function init() {
    setTimeout(() => {
        if (typeof Validation !== 'undefined') {
            Validation.initForms();
        }

        initSelect2();
        initFlatpickr();
        initImask();
        initTooltips();
        initPopovers();
        initMentions();
    }, 200);
}

export function initSelect2() {
    if (typeof Select2Global !== 'undefined') {
        Select2Global.init('[data-select2-init]');
    }
}

export function initTooltips() {
    $('[data-toggle="tooltip"]').tooltip();
    initInfoTooltips();
}

export function initInfoTooltips(parent) {
    parent = typeof parent !== 'undefined'? parent : document;
    // Naprawia pozycję tooltipów przy polach (niebieskie i)
    const tooltips = parent.querySelectorAll('[data-field-info-tooltip]');

    if (tooltips && tooltips.length) {
        tooltips.forEach(tooltip => {
            if (isVisible(tooltip) && !tooltip.hasAttribute('data-tooltip-field-initialized')) {
                const parent = tooltip.parentElement;
                let field = parent.querySelector('.form-control');
                if (field) {
                    const label = field.previousElementSibling;
                    if (field.dataset.hasOwnProperty('select2Init')) {
                        field = field.nextElementSibling;
                    }

                    tooltip.setAttribute('data-tooltip-field-initialized', true);

                    const tooltipTop = label ? label.offsetHeight : 0;
                    const fieldWidth = field.offsetWidth;
                    const tooltipLeft = fieldWidth + 5;
                    const additionalTop = label ? 14 : 7;

                    tooltip.style.left = `${tooltipLeft}px`;
                    tooltip.style.top = `${tooltipTop + additionalTop}px`;
                    field.style.width = `${fieldWidth}px`;
                }
            }
        });
    }
}

export function initPopovers() {
    $('[data-toggle="popover"]').popover({
        boundary: 'window'
    });
}

export function initFlatpickr(runImmediatelyInModal) {
    if (typeof FlatpickrGlobal !== 'undefined') {
        FlatpickrGlobal.init(runImmediatelyInModal);
    }
}

export function initDatatables() {
    if (typeof datatables !== 'undefined') {
        datatables.init();
    }
}

export function initImask() {
    if (typeof IMaskGlobal !== 'undefined') {
        IMaskGlobal.init();
    }
}

export function initDropzone() {
    if (typeof Dropzone !== 'undefined') {
        Dropzone.init();
        Dropzone.removeFile();
    }
}

export function initMentions() {
    if (typeof Mention !== 'undefined') {
        Mention.init();
    }
}

export function resizableTextarea() {
    const tx = document.querySelectorAll('.resizable-textarea');
    tx.forEach(textarea => {
        if (textarea && textarea.classList.contains('emojionearea')) {
            const editor = textarea.querySelector('.emojionearea-editor');
            if (textarea.previousElementSibling.emojioneArea.getText()) {
                textarea.setAttribute('style', `height: ${editor.scrollHeight}px!important;`);
                editor.setAttribute('style', `height: ${editor.scrollHeight}px!important;overflow:hidden`);
            }
        } else if (textarea.value) {
            textarea.setAttribute('style', `height: ${textarea.scrollHeight}px!important;overflow:hidden;${textarea.getAttribute('style')}`);
        }

        textarea.addEventListener('input', setResizableTextarea, false);
    });
}

function setResizableTextarea() {
    let element;
    let originalElement = this;
    if (this.classList.contains('emojionearea')) {
        element = this.querySelector('.emojionearea-editor');
        element.style.height = 'auto';
        element.style.height = (element.scrollHeight) + 'px';
        originalElement.style.height = 'auto';
        originalElement.style.height = (element.scrollHeight) + 'px';
    } else {
        this.style.height = 'auto';
        this.style.height = (this.scrollHeight) + 'px';
    }
}
